var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.5C19.4036 25.5 25 19.9036 25 13C25 6.09644 19.4036 0.5 12.5 0.5C5.59644 0.5 0 6.09644 0 13C0 19.9036 5.59644 25.5 12.5 25.5Z",
    fill: "#CD7F32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8701 15.0455L14.2857 13.7533V7.71427C14.2857 7.24067 14.0975 6.78647 13.7626 6.45158C13.4278 6.1167 12.9735 5.92856 12.4999 5.92856C12.0263 5.92856 11.5721 6.1167 11.2373 6.45158C10.9024 6.78647 10.7142 7.24067 10.7142 7.71427V14.8571C10.7142 15.1888 10.8065 15.5139 10.9808 15.796C11.1551 16.0782 11.4046 16.3062 11.7013 16.4545L15.2727 18.2402C15.6962 18.4507 16.1859 18.4846 16.6343 18.3346C17.0828 18.1845 17.4535 17.8626 17.665 17.4396C17.8765 17.0167 17.9116 16.527 17.7625 16.0782C17.6135 15.6294 17.2926 15.258 16.8701 15.0455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/PendingIcon.72145d41d79addb77ff00c10114c9bd7.svg";
export { ForwardRef as ReactComponent };